export default __webpack_public_path__ + "static/media/portfolio-active.01b25b58.svg";